export default __webpack_public_path__ + "static/media/42.be9a448b.png";